"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var composition_1 = require("./lib/composition");

exports.composeReducer = composition_1.composeReducer;
exports.initialStateReducer = composition_1.initialStateReducer;
exports.fromMap = composition_1.fromMap;
exports.scopeReducers = composition_1.scopeReducers;

var actions_1 = require("./lib/actions");

exports.createFactory = actions_1.createFactory;
exports.createAsyncFactory = actions_1.createAsyncFactory;